import React, { useEffect, useRef } from "react";
import Highcharts from "highcharts";
require("highcharts/modules/accessibility")(Highcharts);

export default function GraphPerQuarter({ summaryReports, height, id, title, series1, series2, yAxisTitle}) {
    let GraphPerQuarterFAQuartlyBudget;
    let GraphPerQuarterFAQuartlyActualInvestment;
    let GraphPerQuarterDAQuartlytargetManufacture;
    let GraphPerQuarterDAQuartlygizmosManufacture;
    let Data1ValuesQuarters;
    let Data2ValuesQuarters;
    const chartRef = useRef(null);
    //Databinding for QuarterFinancialAnalysis
    if(id==="QuarterFinancialAnalysis"){
        GraphPerQuarterFAQuartlyBudget = summaryReports?.FinancialAnalysis?.QuartlyBudget;
        Data1ValuesQuarters = GraphPerQuarterFAQuartlyBudget ? Object.values(GraphPerQuarterFAQuartlyBudget) : null;
        GraphPerQuarterFAQuartlyActualInvestment = summaryReports?.FinancialAnalysis?.QuartlyActualInvestment;
        Data2ValuesQuarters = GraphPerQuarterFAQuartlyActualInvestment ? Object.values(GraphPerQuarterFAQuartlyActualInvestment).map(value => parseFloat(value)) : null;
        //console.log(Data1ValuesQuarters,Data2ValuesQuarters)
    }
    //Databinding for QuarterDecisionAnalysis
    else{
        GraphPerQuarterDAQuartlytargetManufacture = summaryReports?.DecisionAnalysis?.targetManufacture;
        Data1ValuesQuarters = GraphPerQuarterDAQuartlytargetManufacture ? Object.values(GraphPerQuarterDAQuartlytargetManufacture) : null;
        GraphPerQuarterDAQuartlygizmosManufacture = summaryReports?.DecisionAnalysis?.gizmosManufacture;
        Data2ValuesQuarters = GraphPerQuarterDAQuartlygizmosManufacture ? Object.values(GraphPerQuarterDAQuartlygizmosManufacture).map(value=> parseFloat(value)) : null;
        //console.log(Data1ValuesQuarters,Data2ValuesQuarters)
    }
    
    function applyDemandVarianceAccessibility(chart) {
        if (chart && chart.renderTo) {
            const svg = chart.renderTo.querySelector("svg");
             // Defensive fallback for missing id
            if (!chart.renderTo.id) {
            chart.renderTo.id = "fallback-id-" + Math.random().toString(36).substr(2, 5);
            console.warn("Chart renderTo had no id. Assigned fallback id:", chart.renderTo.id);
            }

            if (svg) {
            setTimeout(() => {
            const chartId = chart.renderTo.id;

            let ariaLabel = '';
            let descText = '';

            if (chartId === "QuarterFinancialAnalysis") {
                ariaLabel = "Grouped column chart comparing budget and actual spending per quarter.";
                descText = "This chart displays a quarterly comparison between the budgeted and actual financial expenditures. Orange patterned bars represent the budget, while blue bars represent actual spendings for each quarter from Quarter 1 to Quarter 4.";
            } else if (chartId === "QuarterDecisionAnalysis") {
                ariaLabel = "Grouped column chart comparing target and actual gizmos manufactured per quarter.";
                descText = "This chart shows the target versus actual number of gizmos manufactured across four quarters. Orange patterned bars represent the target quantities, and blue bars represent the actual manufactured quantities for each quarter.";
            }

            svg.setAttribute("role", "img");
            svg.setAttribute("aria-label", ariaLabel);

            const oldDesc = svg.querySelector("desc");
            if (oldDesc) oldDesc.remove();

            const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
            desc.textContent = descText;
            svg.insertBefore(desc, svg.firstChild);
            },0);
            }
        }
    }


    var chart = {
        type: 'column',
        events: {
            render: function () {
            setTimeout(() =>  applyDemandVarianceAccessibility(this),100);
            },
            redraw: function () {
            setTimeout(() =>  applyDemandVarianceAccessibility(this),100);
            }
        }
    };
    var title = {
        text: `${title}`,
        align: "left",
        style: {
            fontSize: "14px",
        },
    };
    var credits = {
        enabled: false, // Disable the Highcharts bottom link
    };
    var tooltip = {
        // format: '<strong>{key}</strong><br/>{series.name}: <strong>{y}</strong><br/>',
        formatter: function () {
            var tooltipText = `<strong>${this.x}</strong>` + '<br/>';
            if (this.series.name === `${series1}`) {
                tooltipText += '<span style="color: #D46719;">' + this.series.name + '</span>: <strong style="font-weight: bold;">' + `${(`${id}` == 'graph1') ? '$' : ''}` + Highcharts.numberFormat(this.y, 0, ',', ',') + '</strong>';
            } else if (this.series.name === `${series2}`) {
                tooltipText += '<span style="color: #005A70;">' + this.series.name + '</span>: <strong style="font-weight: bold;">' + `${(`${id}` == 'graph1') ? '$' : ''}` + Highcharts.numberFormat(this.y, 0, ',', ',') + '</strong>';
            }
            return tooltipText;
        },
        borderWidth: 1,
        style: {
            borderColor: function () {
                return this.point.color; // Set the tooltip box border color to match the point color
            },
            opacity: 0.9,
            fontSize: '14px',
        }
    };
    var legend = {
        enabled: false,
        align: "left",
        itemStyle: {
            fontWeight: "bold",
            fontSize: "11px",
        },
    };

    var plotOptions = {
        column: {

            dataLabels: {
                enabled: false,
                style: {
                    textOutline: "none",
                },
            },
        },
        series: {
            events: {
                legendItemClick: function () {
                    return false;
                }
            }
        }
    };
    var series = [
        {
            name: `${series1}`,
            //data: [summaryReports?.DemandAnalysis?.forecastedDemands?.REGULAR,summaryReports?.DemandAnalysis?.forecastedDemands?.MIDGRADE,summaryReports?.DemandAnalysis?.forecastedDemands?.PREMIUM],
            data: Data1ValuesQuarters,
            //color: "#D46719",
            color: {
                pattern: {
                  path: 'M 0 0 L 10 10 M 0 10 L 10 0', // Diagonal cross pattern
                  width: 10,
                  height: 10,
                  color: "#D46719",
                }
              }

        },
        {
            name: `${series2}`,
            //data: [summaryReports?.DemandAnalysis?.actualDemands?.REGULAR,summaryReports?.DemandAnalysis?.actualDemands?.MIDGRADE,summaryReports?.DemandAnalysis?.actualDemands?.PREMIUM],
            data: Data2ValuesQuarters,
            //color: "#005A70",
            color: {
                pattern: {
                    path: 'M 0 5 L 10 5', // Horizontal line
                    width: 10,
                    height: 10,
                    color: '#FFFFFF', // Line color (white)
                    backgroundColor: '#005A70' 
                }
            },

        }
    ];
    var xAxis = {
        categories: ['Quarter-1', 'Quarter-2', 'Quarter-3', 'Quarter-4'],
        title: {
            text: "Quarter",
        },
        lineColor: '#EFEFEC',
        labels: {
            step: 1,
            padding: 0,
            rotation: -45,
        },
    }
    var yAxis = {
        allowDecimals: false,
        crosshair: true,
        tickAmount: 6,
        tickInterval: null,
        min: 0,
        title: {
            text: `${yAxisTitle}`
        }
    }
    var accessibility = {
        enabled: true,
        screenReaderSection: {
            beforeChartFormat: '' // disables their auto "Interactive chart" label
        }
    };
    var json = {};
    json.chart = chart;
    json.credits = credits;
    json.title = title;
    json.tooltip = tooltip;
    json.legend = legend;
    json.series = series;
    json.xAxis = xAxis;
    json.yAxis = yAxis;
    json.plotOptions = plotOptions;
    json.accessibility = accessibility;
    // const initGraph = () => {
    //     // Highcharts.chart(`${id}`, json);
    //     //console.log(json);
    // };
    const initGraph = () => {
        if (chartRef.current) {
            if (!chartRef.current.id) {
            chartRef.current.id = id;
            }

            const chartOptions = {
            ...json,
            chart: {
                ...json.chart,
                renderTo: chartRef.current, // optional (but safe)
                type: 'column',
                events: {
                render: function () {
                    setTimeout(() => applyDemandVarianceAccessibility(this), 100);
                },
                redraw: function () {
                    setTimeout(() => applyDemandVarianceAccessibility(this), 100);
                }
                }
            }
            };

            Highcharts.chart(chartRef.current, chartOptions);
        }
    };
    useEffect(() => {
        initGraph();
    }, [summaryReports]);
    return (
        <div
            // id={id}
            ref={chartRef}
            style={{ height }}
            title={title.text}
            aria-label="Cost Analysis Graph"
            className="costAnalysis"
        ></div>
    );
}
